import { useEffect } from "react";

const DEFAULT_TITLE = "Starting Point Agency | Agenzia Marketing a 360° Social-First";
const DEFAULT_DESC = "Agenzia di marketing a 360° social-first a Catania. Partiamo dai social e costruiamo tutto ciò che serve al tuo brand: contenuti, branding, siti web.";

const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export function useSeo({ title, description } = {}) {
  useEffect(() => {
    if (!title) return;
    const desc = description || DEFAULT_DESC;
    document.title = title;
    setMeta('meta[name="description"]', desc);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', desc);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', desc);
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', DEFAULT_DESC);
      setMeta('meta[property="og:title"]', DEFAULT_TITLE);
      setMeta('meta[property="og:description"]', DEFAULT_DESC);
      setMeta('meta[name="twitter:title"]', DEFAULT_TITLE);
      setMeta('meta[name="twitter:description"]', DEFAULT_DESC);
    };
  }, [title, description]);
}
